export enum ACCOUNT_NOTIFICATION_TYPE {
    EXPIRED = 'EXPIRED',
    ALMOST_EXPIRED = 'ALMOST_EXPIRED',
    LOW_BALANCE = 'LOW_BALANCE',
}

export enum ACCOUNT_COOKIE_NAME {
    EXPIRED = 'TS_ACCOUNT_EXPIRED',
    ALMOST_EXPIRED = 'TS_ACCOUNT_ALMOST_EXPIRED',
    LOW_BALANCE = 'TS_ACCOUNT_LOW_BALANCE',
}
